module.exports = __webpack_public_path__ + "img/new_tag.987e2f81.png";